import React, { useState, useEffect } from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';
import useCommonStore from '../../hooks/useCommonStore';

const RouteGuard = observer((props) => {
  const commonStore = useCommonStore();
  const location = useLocation();
  const [isLogin, setIsLogin] = useState(true);

  useEffect(() => {
    // Skip check if force logout is in progress
    if (window.forceLogoutInProgress) {
      return;
    }
    
    commonStore.isLogin().then((res) => {
      // Double check flag before updating state
      if (window.forceLogoutInProgress) {
        return;
      }
      
      if (res.code === 200) {
        setIsLogin(true);
      } else {
        setIsLogin(false);
      }
    });
  }, []);

  useEffect(() => {
    // Skip check if force logout is in progress
    if (window.forceLogoutInProgress) {
      return;
    }
    
    if (!commonStore.loginCheck) {
      commonStore.isLogin().then((res) => {
        // Double check flag before updating state
        if (window.forceLogoutInProgress) {
          return;
        }
        
        if (res.code === 200) {
          setIsLogin(true);
        } else {
          setIsLogin(false);
        }
      });
    }
  }, [commonStore.loginCheck]);

  // Don't redirect if force logout is in progress (will be handled by socketUtil)
  if (window.forceLogoutInProgress) {
    return <Route {...props} />;
  }

  if (isLogin) {
    return <Route {...props} />;
  } else {
    const queryParams = new URLSearchParams(location.search);
    const redirect = queryParams.get("redirect");
    
    if (redirect) {
      return <Redirect to={`/auth/login?redirect=${redirect}`} />;
    }
    return <Redirect to={'/auth/login'} />;
  }
});

export default RouteGuard;
